/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Spaces_Moving_ItemsInputs */



/**
* | output |
* | --- |
* | "Moving {count} item(s)..." |
*
* @param {Spaces_Moving_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_moving_items = /** @type {((inputs: Spaces_Moving_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Moving_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Element(e) wird/werden verschoben...`)
	return /** @type {LocalizedString} */ (`Moving ${i?.count} item(s)...`)
});